export enum PixinTypeEnum {
  'Pix Processando' = 1,
  'Pix Recebido' = 2,
  'Pix Cancelado' = 3,
  'Pix Devolvido' = 4
}
